/**
 * Card (board 17): the ONE panel component (replaces the two legacy Panels and the
 * theme/brand panels). Radius 12, a 1 px line, no shadow (shadows are for popovers only).
 */
import React from 'react';

export interface CardProps extends React.HTMLAttributes<HTMLElement> {
  /** The card's title, rendered as a sentence-case heading (h3, ~15px, ink). Review
   *  decision 33 (2026-10-13): it was a small mono uppercase label; write it in sentence
   *  case ("Who works it"), never in caps. */
  label?: React.ReactNode;
  /** Right side of the heading row: a LiveDot, a link, one action. */
  aside?: React.ReactNode;
  padded?: boolean;
  as?: 'section' | 'div' | 'article';
}

export function Card({ label, aside, padded = true, as: Tag = 'section', className, children, ...rest }: CardProps) {
  return (
    <Tag className={['ds-card', padded && 'ds-card--pad', className].filter(Boolean).join(' ')} {...rest}>
      {label || aside ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--ds-s2)', marginBottom: 'var(--ds-s3)' }}>
          {label ? <h3 className="ds-card-title">{label}</h3> : null}
          {aside ? <span style={{ marginLeft: 'auto' }}>{aside}</span> : null}
        </div>
      ) : null}
      {children}
    </Tag>
  );
}
